import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  labelSwitch: (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'spaceAround',
    width: 'auto',
    position: 'relative',
    borderRadius: theme.sizes.base * 12.5,
    cursor: 'pointer',
    overflow: 'hidden',
    '&:before': {
      content: '""',
      position: 'absolute',
      height: '100%',
      width: `calc(100% / ${props.length})`,
      backgroundColor: theme.colors[props._color].normal,
      transitionDuration: `${theme.speed.fast}ms`,
      transitionTimingFunction: 'cubic-bezier(.25,.46,.45,.94)',
      transitionProperty: 'transform',
      willChange: 'transform',
      transform: `translateX(calc(${theme.direction.value === 'rtl' ? -100 : 100}% * ${props.indexOfValue}))`,
      borderRadius: theme.sizes.base * 12.5,
      zIndex: 0,
      border: [['solid', 2, theme.colors.background.normal]],
      boxSizing: 'border-box',
    },
    '& > .label': {
      position: 'relative',
      userSelect: 'none',
      flex: 1,
      borderRadius: theme.sizes.base * 12.5,
      color: theme.colors.background.contrast(20),
      textAlign: 'center',
      overflow: 'hidden',
      fontWeight: 'bold',
      '&.active': {
        color: theme.colors[props._color].text,
      },
    },
    '&[disabled]': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  }),
}));

export default useStyle;
